import type { DeviceKeyPair, GetOrCreateKeyPairResult } from './deviceCrypto.types';

export type { DeviceKeyPair, GetOrCreateKeyPairResult };

function throwNotSupported(): never {
  throw new Error('Device crypto operations are not supported on web');
}

export async function generateKeyPair(): Promise<DeviceKeyPair> {
  throwNotSupported();
}

export async function exportPublicKeyPem(_publicKey: unknown): Promise<string> {
  throwNotSupported();
}

export async function exportPrivateKeyJwk(_privateKey: unknown): Promise<unknown> {
  throwNotSupported();
}

export async function importPrivateKeyJwk(_jwk: unknown): Promise<unknown> {
  throwNotSupported();
}

export async function decryptPassword(_encryptedBase64: string, _profileId: number): Promise<string> {
  throwNotSupported();
}

export async function deleteKeyPair(_profileId: number): Promise<void> {
  throwNotSupported();
}

export async function hasStoredKeyPair(_profileId: number): Promise<boolean> {
  return false;
}

export async function getOrCreateKeyPair(_profileId: number): Promise<GetOrCreateKeyPairResult> {
  throwNotSupported();
}

export async function signChallenge(_challengeBase64: string, _profileId?: number): Promise<string> {
  throwNotSupported();
}

export function clearCachedKeys(_profileId?: number): void {
  // No-op on web
}
